export default {
  reviewDate: {
    id: 'product_reviews_user_comment_review_date',
    defaultMessage: 'Reviewed in {country} on {date}',
  },
  purchaseDate: {
    id: 'product_reviews_user_comment_purchase_date',
    defaultMessage: 'Purchased on {date}',
  },
  showMore: {
    id: 'product_reviews_user_comment_more',
    defaultMessage: 'Show more',
  },
  showLess: {
    id: 'product_reviews_user_comment_less',
    defaultMessage: 'Show less',
  },
  textTranslatedFrom: {
    id: 'translated_from',
    defaultMessage: 'Translated from {lang}',
  },
  seeOriginalText: {
    id: 'see_original_text',
    defaultMessage: 'See original',
  },
  translateTextTo: {
    id: 'translate_to',
    defaultMessage: 'Translate to {lang}',
  },
  errorToastTitle: {
    id: 'translation_error_title',
    defaultMessage: 'Oops, something went wrong.',
  },
  errorToastMessage: {
    id: 'translation_error_message',
    defaultMessage:
      'Our server is a bit slow at the moment. Please give it a sec and try again.',
  },
}
